import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VForm,
    {
      ref: "form",
      staticClass: "attribute-filter",
      model: {
        value: _vm.isValid,
        callback: function ($$v) {
          _vm.isValid = $$v
        },
        expression: "isValid",
      },
    },
    [
      _c("vuex-select", {
        staticClass: "attribute-filter-values",
        attrs: {
          "item-value": "attributeKey",
          "item-text": "attributeName",
          autocomplete: "",
          "value-type": "object",
          getter: _vm.getAttribute,
          setter: (value) => _vm.setAttribute(value),
          options: _vm.attributeOptions,
          validations: _vm.validateAttributeSelect ? _vm.validations : [],
          "prioritize-exact-match": "",
        },
      }),
      _vm._v(" "),
      _c("vuex-select", {
        staticClass: "attribute-filter-values",
        attrs: {
          autocomplete: "",
          chips: "",
          multiple: "",
          disabled: !_vm.atributeValuesOptions.length,
          getter: () => _vm.getAttributeValues(),
          setter: _vm.setAttributeValues,
          options: _vm.atributeValuesOptions,
          validations: _vm.validations,
          "sort-function": _vm.naturalSortOptions,
          "prioritize-exact-match": "",
          "return-object": "",
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pt-1" },
        [
          _vm.isLoading
            ? _c("spinner-dynamic")
            : _c(
                VBtn,
                {
                  attrs: {
                    disabled: _vm.isReadOnly || _vm.removeBtnDisabled,
                    icon: "",
                  },
                  on: { click: _vm.onRemoveAttributeRow },
                },
                [
                  _c("icon", {
                    attrs: {
                      "icon-name": "cancel",
                      small: "",
                      "icon-colour-type": "primary-path",
                    },
                  }),
                ],
                1
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }